module.exports = __webpack_public_path__ + "img/otkrit-mob.8cf7d381.png";